import styled from 'styled-components';

export default styled.div`
	display: flex;
	gap: var(--gap);
	align-items: center;
`;
